export { DynamicForgotPasswordForm } from './DynamicForgotPasswordForm';
